import React from 'react';
import { NavLink } from 'react-router-dom'

const TopNavbar = () => {
  return (
    <div className=" "> 
        
        <div  className='fixed top-12 right-0 h-12  left-0 justify-items-stretch w-full  content-center bg-[#fbc901] items-center z-50 '>
    <nav className='flex justify-between '>
        {/*<Link to="/home" className='mr-4 text-lg '>Home</Link>
        <Link to="/references" className='mr-4 text-lg '>References</Link>*/}
        <NavLink to="/learning" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' // Active styles
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' // Inactive styles
        }
      ><strong>Learning</strong></NavLink>
       
        {/*<NavLink to="/feedback" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' // Active styles
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' // Inactive styles
        }
      >Descriptive Feedback</NavLink>
        <NavLink to="/international" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' // Active styles
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' // Inactive styles
        }
      >International</NavLink>*/}
        <NavLink to="/tutoring" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' // Active styles
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' // Inactive styles
        }
      ><strong>Tutoring</strong></NavLink>
        {/*<Link to="/assessors" className='mr-4 text-lg '>Find a Mock Examiner/Assessor</Link>
        <Link to="/connect" className='mr-4 text-lg '>Be a Tutor</Link>
        <NavLink to="/futurize" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' // Active styles
            : 'text-shadow-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' // Inactive styles
        }
      >Futurize Skills</NavLink>*/}
        <NavLink to="/assessment" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' // Active styles
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' // Inactive styles
        }
      ><strong>Assessment</strong></NavLink> 

    
               
    </nav> 
    </div> 
    </div>    

  );
}

export default TopNavbar;
